import { KoobInputSelectField } from '@koob/ui';
import { useField } from 'formik';

// Multi-select for experience options: best-match items (from compatibility
// scoring) are sorted first and flagged with a medal icon, and unselecting an
// option also removes it from a linked formik field (e.g. `extras`).
// A form shows several per day and per option: each loads its list on first
// open, not at mount.
const ExperienceOptionsSelectField = ({
  bestMatches,
  clearFieldName,
  onSelectOption,
  ...props
}) => {
  const [{ value: linked }, , { setValue: setLinked }] =
    useField(clearFieldName);

  const isBestMatch = (item) =>
    (bestMatches ?? []).some((best) => best.value === item?.id);

  return (
    <KoobInputSelectField
      multiple
      lazy
      transformItems={(items) =>
        [...items].sort(
          (a, b) => Number(isBestMatch(b)) - Number(isBestMatch(a)),
        )
      }
      renderOption={(item) => item.name}
      renderValue={(item) => item.name}
      renderOptionContent={(item) => (
        <span className="flex w-full items-center justify-between gap-2">
          <span>{item.name}</span>
          {isBestMatch(item) && <i className="fa-regular fa-medal" />}
        </span>
      )}
      onSelectOption={onSelectOption}
      onUnselectOption={(item) =>
        setLinked((linked ?? []).filter((chunk) => chunk?.id !== item?.id))
      }
      {...props}
    />
  );
};

export default ExperienceOptionsSelectField;
